import ReactECharts from "echarts-for-react";

import processTreemapData from "../utils/processTreemapData";
import useLocale from "../hooks/useLocale";
import { formatNumber } from "../utils/utils";

export default function CardGraph({ item }) {
    const locale = useLocale();
    const optionState = {
        series: [
            {
                type: "treemap",
                roam: "move",
                data: processTreemapData(item, locale),
            },
        ],
        tooltip: {
            formatter: function (info) {
                return `<strong class="tooltip-title">${info.data.name}</strong>
                <p>Monto operado: ${formatNumber(info.data.value, locale, 2)}</p>
                <p>Variación: ${formatNumber(info.data.variation, locale, 2)}</p>`;
            },
        },
    };

    return (
        <div className="cot-card-graph">
            <h4 className="paragraph title">{item.titulo[locale]}</h4>
            <ReactECharts style={{ height: "300px", width: "40vw" }} option={optionState} />
        </div>
    );
}
